<template>
    <v-app>
        <!-- Professional Top Bar -->
        <v-app-bar :color="APP_Color" elevation="0" height="56" class="premium-topbar">
            <v-app-bar-nav-icon @click="drawer = !drawer" color="white" class="menu-btn" />

            <router-link :to="{ path: '/' }" class="app-branding" @click="goHome">
                <span class="brand-text">ERA</span>
                <span class="brand-badge">ERP</span>
            </router-link>

            <v-spacer />

            <!-- Company Selector -->
            <v-menu offset-y max-width="400">
                <template #activator="{ props }">
                    <v-btn v-bind="props" variant="text" class="company-selector" prepend-icon="mdi-domain">
                        <span class="company-text">{{ currentCompanyName }}</span>
                        <v-icon class="ml-1" size="18">mdi-chevron-down</v-icon>
                    </v-btn>
                </template>

                <v-card class="company-dropdown" elevation="12">
                    <div class="dropdown-header">
                        <div class="dropdown-header-content">
                            <v-icon color="white" size="20">mdi-office-building</v-icon>
                            <span class="dropdown-title">Companii</span>
                        </div>
                        <v-chip size="x-small" color="white" variant="outlined">
                            {{ companies.length }}
                        </v-chip>
                    </div>

                    <v-list density="compact" class="company-list">
                        <v-list-item v-for="c in companies" :key="c.ID" @click="switchCompany(c)"
                            :active="c.ID === currentCompanyId" :color="APP_Color" class="company-list-item">
                            <template #prepend>
                                <v-avatar :color="c.ID === currentCompanyId ? APP_Color : 'grey-lighten-3'" size="32"
                                    class="company-avatar">
                                    <v-icon :color="c.ID === currentCompanyId ? 'white' : 'grey-darken-1'" size="18">
                                        mdi-domain
                                    </v-icon>
                                </v-avatar>
                            </template>

                            <v-list-item-title class="company-name">
                                {{ c.Name }}
                            </v-list-item-title>

                            <template #append>
                                <v-icon v-if="c.ID === currentCompanyId" :color="APP_Color" size="20">
                                    mdi-check-circle
                                </v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

            <!-- User Section -->
            <div class="user-section">
                <v-avatar :color="APP_Color" size="32">
                    <v-icon color="white" size="18">mdi-account</v-icon>
                </v-avatar>
                <span class="user-name">{{ Username }}</span>
            </div>

            <!-- Version -->
            <v-chip :color="APP_Color" variant="text" size="small" class="version-badge"
                @click="showAllChangelog = true">
                <v-icon size="12" class="mr-1">mdi-information</v-icon>
                v{{ APP_Version }}
            </v-chip>
        </v-app-bar>

        <!-- Ultra Premium Navigation Drawer -->
        <v-navigation-drawer app v-model="drawer" :color="APP_Color" theme="dark" :elevation="0" permanent
            class="premium-drawer">


            <!-- Menu List -->
            <v-list v-model:opened="open" class="drawer-menu-list">
                <template v-for="row in Menu.filter(x => x.Level == 1)" :key="row.ID">
                    <v-list-group v-if="Menu.some(x => x.MenuID == row.ID)" :prepend-icon="row.Icon"
                        class="menu-group-item">
                        <template v-slot:activator="{ props }">
                            <v-list-item v-bind="props" :title="row.Title" class="menu-parent-item" />
                        </template>

                        <!-- LEVEL 2 -->
                        <template v-for="row2 in Menu.filter(x => x.MenuID == row.ID)" :key="row2.ID">
                            <v-list-group v-if="Menu.some(x => x.MenuID == row2.ID)" no-action
                                class="menu-subgroup-item">
                                <template v-slot:activator="{ props }">
                                    <v-list-item v-bind="props" :title="row2.Title" class="menu-child-item" />
                                </template>

                                <!-- LEVEL 3 -->
                                <v-list-item v-for="row3 in Menu.filter(x => x.MenuID == row2.ID)" :key="row3.ID"
                                    :title="row3.Title" @click="ShowPage(row3.Title, row3.Url)"
                                    class="menu-grandchild-item" />
                            </v-list-group>

                            <!-- Level 2 fără copii -->
                            <v-list-item v-else :title="row2.Title" @click="ShowPage(row2.Title, row2.Url)"
                                class="menu-child-item" />
                        </template>
                    </v-list-group>

                    <!-- Level 1 fără copii -->
                    <v-list-item v-else :title="row.Title" :prepend-icon="row.Icon"
                        @click="ShowPage(row.Title, row.Url)" class="menu-single-item" />
                </template>
            </v-list>

            <!-- Drawer Footer -->
            <template v-slot:append>
                <div class="drawer-footer-section">
                    <v-divider class="footer-divider" />
                    <v-list-item prepend-icon="mdi-power-standby" title="Deconectare" @click="Logout"
                        class="logout-item">
                        <template #append>
                            <v-icon size="18">mdi-exit-to-app</v-icon>
                        </template>
                    </v-list-item>
                </div>
            </template>
        </v-navigation-drawer>
        <!-- Main Content Area -->
        <v-main class="main-content-area">
            <v-container fluid class="content-container">
                <v-card class="content-card" elevation="8">
                    <!-- Fixed Card Header -->
                    <div v-if="!$route.path.startsWith('/documente')" class="card-header-fixed">
                        <!-- <v-card-title class="card-title-section">
                            <v-icon :color="APP_Color" size="24" class="mr-3">mdi-file-document-outline</v-icon>
                            <span>{{ TabTitle || 'Panou Principal' }}</span>
                        </v-card-title> -->

                        <!-- Breadcrumbs -->
                        <div v-if="breadcrumb.length" class="breadcrumb-section">
                            <VBreadcrumbs :items="breadcrumb" class="breadcrumb-custom">
                                <template v-slot:divider>
                                    <v-icon size="14" color="grey">mdi-chevron-right</v-icon>
                                </template>
                                <template v-slot:item="{ item }">
                                    <VBreadcrumbsItem :link="!!item.url"
                                        :style="item.url ? 'cursor: pointer' : ''"
                                        @click="item.url && ShowPage(item.title, item.url)">
                                        {{ item.title }}
                                    </VBreadcrumbsItem>
                                </template>
                            </VBreadcrumbs>
                        </div>

                        <v-divider :color="APP_Color" class="header-divider" />
                    </div>

                    <!-- Scrollable Content -->
                    <div class="card-content-scrollable">
                        <router-view class="router-content" />
                    </div>
                </v-card>
            </v-container>
        </v-main>

        <v-footer app>
            <!-- -->
        </v-footer>

        <!-- Dialog ultimele update-uri -->
        <v-dialog v-model="showChangelog" max-width="500px" persistent>
            <v-card>
                <v-card-title class="text-h6 d-flex align-center">
                    <v-icon class="mr-2" color="primary">mdi-new-box</v-icon>
                    Ce e nou în versiunea {{ APP_Version }}
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <!-- Modulele afectate -->
                    <div v-if="latestUpdate[0]?.modules?.length" class="mb-2">
                        <strong>Module afectate:</strong>
                        <v-chip v-for="mod in latestUpdate[0].modules" :key="mod" small class="ma-1" color="primary"
                            text-color="white">
                            {{ mod }}
                        </v-chip>
                        <v-divider class="my-2"></v-divider>
                    </div>

                    <!-- Lista modificărilor -->
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    {{ latestUpdate[0]?.description }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn color="primary" text @click="markAsSeen">Am înțeles</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>





        <!-- Dialog istoricul complet -->
        <v-dialog v-model="showAllChangelog" max-width="600px" persistent>
            <v-card>
                <v-card-title class="text-h6">Istoricul complet al versiunilor</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="max-height: 400px; overflow-y: auto;">
                    <v-sheet v-for="entry in changelog" :key="entry.version" class="pa-3 mb-3 rounded-lg" elevation="2"
                        color="grey-lighten-4">
                        <div class="d-flex justify-space-between align-center mb-1">
                            <span class="font-weight-medium">{{ entry.version }}</span>
                            <span class="text-caption grey--text">{{ formatDate(entry.date) }}</span>
                        </div>
                        <div>{{ entry.description }}</div>
                        <div v-if="entry.modules?.length" class="mt-1 text-caption grey--text">
                            Module: {{ entry.modules.join(", ") }}
                        </div>
                    </v-sheet>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="showAllChangelog = false">Închide</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-app>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { useChangelog } from '@/composable/useChangelog';
import AppSettings from '@/settings/appSettings'
import JwtServices from '@/services/JwtServices';
import PreturiFurnizor from './Comercial/PreturiFurnizor.vue'
import Documente from './Documente/Documente.vue';
import RaportCashFlowView from './Rapoarte/RaportCashFlowView.vue';
import Oportunitati from './Comercial/CRM/Oportunitati.vue'
import AdminView from './ADMIN/Admin.vue'
import Nomenclatoare from './ADMIN/Nomenclatoare.vue'
import Calendar from './Calendar/Calendar.vue';
import GridContacte from './Comercial/CRM/GridContacte.vue';
import GridOportunitati from './Comercial/CRM/GridOportunitati.vue';
import GridTabActivitati from './Comercial/CRM/GridTabActivitati.vue';
import GridRoluri from './AUTH/GridRoluri.vue';
import GridRoluriUtilizatori from './AUTH/GridRoluriUtilizatori.vue';
import GridDrepturiCustom from './AUTH/GridDrepturiCustom.vue';
import GridDrepturiUtilizatori from './AUTH/GridDrepturiUtilizatori.vue';
import GridDrepturiRoluri from './AUTH/GridDrepturiRoluri.vue';
import GridBilanturi from './Contabilitate/GridBilanturi.vue';
import GridFormuleRanduri from './Contabilitate/GridFormuleRanduri.vue';
import GridTabMeniuBilanturi from './Contabilitate/GridTabMeniuBilanturi.vue';
import CompanyServices from "@/services/CompanyService";
import drepturi from "@/settings/drepturi";
import GridDrepturiCustomsiMeniu from './AUTH/GridDrepturiCustomsiMeniu.vue';
import GridUtilizatorisiDrepturi from './AUTH/GridUtilizatorisiDrepturi.vue';
import GridRolurisiDrepturi from './AUTH/GridRolurisiDrepturi.vue';
import GridUtilizatori from './AUTH/GridUtilizatori.vue';
import { VBreadcrumbs, VBreadcrumbsItem } from 'vuetify/components'
import CompanyService from '@/services/CompanyService';
import notify from 'devextreme/ui/notify';
export default defineComponent({
    name: 'HomeView',

    components: {
        VBreadcrumbs,
        VBreadcrumbsItem,
        AppSettings,
        PreturiFurnizor,
        Documente,
        RaportCashFlowView,
        Oportunitati,
        AdminView,
        Nomenclatoare,
        Calendar,
        GridContacte,
        GridOportunitati,
        GridTabActivitati,
        GridRoluri,
        GridRoluriUtilizatori,
        GridDrepturiCustom,
        GridDrepturiUtilizatori,
        GridDrepturiRoluri,
        GridBilanturi,
        GridFormuleRanduri,
        GridTabMeniuBilanturi,
        GridDrepturiCustomsiMeniu,
        GridUtilizatorisiDrepturi,
        GridRolurisiDrepturi,
        GridUtilizatori
    },

    data() {
        return {
            showChangelog: false,
            showAllChangelog: false,
            newUpdates: [] as Array<any>,
            changelog: [] as Array<any>,
            breadcrumb: [] as any[],
            drawer: false,
            openMenu: null,
            open: ['Documente'],
            APP_Color: AppSettings.APP_Color,
            APP_Version: AppSettings.APP_Version,
            Username: " ",
            currentView: "",
            TabTitle: '',
            Menu: [],
            companies: [] as Array<{ ID: string; Name: string }>,
            currentCompanyId: '' as string
        }
    },
    methods: {
        acknowledgeUpdates() {
            this.markAsSeen();        // marchează versiunea ca văzută
            this.showChangelog = false; // închide dialogul
        },
        formatDate(iso: string) {
            const d = new Date(iso);
            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        },
        GetUser() {
            this.Username = JwtServices.GetUsername();
        },
        ShowPage(Title: string, Url: string) {
            this.$router.push({ name: Url });
            this.TabTitle = Title;
            this.breadcrumb = this.getBreadcrumb(Url).map(x => ({ title: x.Title, url: x.Url }));
            this.drawer = false;
        },
        Logout() {
            localStorage.removeItem("ERA_Jwt");
            localStorage.removeItem("ERA_Company");
            this.$router.go(0);
        },
        getBreadcrumb(url: string) {
            const crumbs: any[] = [];
            let current = this.Menu.find((x: any) => x.Url === url);
            while (current) {
                crumbs.unshift(current);
                current = this.Menu.find((x: any) => x.ID == current.MenuID);
            }
            return crumbs;
        },
        loadCompaniesFromStorage() {
            try {
                const raw = localStorage.getItem('ERA_Companies');
                this.companies = raw ? JSON.parse(raw) : [];
            } catch { this.companies = []; }

            try {
                const current = localStorage.getItem('ERA_Company');
                const obj = current ? JSON.parse(current) : null;
                this.currentCompanyId = obj?.ID || '';
            } catch { this.currentCompanyId = ''; }
        },

        async switchCompany(c: { ID: string; Name: string }) {
            notify('Modificarea companiei poate dura câteva momente', 'success', 3000);
            if (c.ID === this.currentCompanyId) return;

            try {
                const resp = await CompanyServices.switchCompany({ companyID: c.ID });
                const { token, company } = resp.data as { token: string; company: { ID: string; Name: string } };

                localStorage.setItem('ERA_Jwt', token);
                localStorage.setItem('ERA_Company', JSON.stringify(company));

                this.currentCompanyId = company.ID;


                await this.reloadMenusAfterSwitch();


                this.$router.go(0);
            } catch (e: any) {

                console.error(e);
            }
        },

        async reloadMenusAfterSwitch() {

            const response1 = await CompanyServices.getMenus();
            this.Menu = [];
            response1.data.forEach((x: any) => this.Menu.push(JSON.parse(x.MeniuConfig)));
        },
        goHome() {
            this.TabTitle = '';
            this.breadcrumb = [];
            this.dynamicParents = {};
        },
        updateBreadcrumbs(route: any, from: any = null) {
            const routeName = route.name as string;
            if (!routeName) return;

            // Initialize dynamicParents if needed
            if (!this.dynamicParents) this.dynamicParents = {};

            const customParents: Record<string, string> = {
                'GridContacte': 'CRMDashboard',
                'GridContactDetalii': 'GridContacte',
                'GridOportunitati': 'CRMDashboard',
                'GridTabActivitati': 'CRMDashboard',
                'Calendar': 'CRMDashboard',
                'GridParteneri': 'CRMDashboard',
                'GridCampanii': 'CRMDashboard',
                'CalendarActivitati': 'CRMDashboard'
            };

            const customTitles: Record<string, string> = {
                'GridContactDetalii': 'Detalii Contact'
            };

            // Dynamic Parent Logic
            if (from && from.name && from.name !== routeName) {
                // Logic for GridContacte
                if (routeName === 'GridContacte') {
                    if (from.name === 'GridParteneri') {
                        this.dynamicParents[routeName] = from.name;
                    } else {
                        // Reset to default
                        delete this.dynamicParents[routeName];
                    }
                }
                // Logic for GridOportunitati
                else if (routeName === 'GridOportunitati') {
                    if (from.name === 'GridContacte') {
                        this.dynamicParents[routeName] = from.name;
                    }
                    else if (from.name === 'GridContactDetalii') {
                        this.dynamicParents[routeName] = from.name;
                    }
                    else {
                        delete this.dynamicParents[routeName];
                    }
                }
                // Logic for GridTabActivitati
                else if (routeName === 'GridTabActivitati') {
                    if (from.name === 'GridContacte') {
                        this.dynamicParents[routeName] = from.name;
                    } else {
                        delete this.dynamicParents[routeName];
                    }
                }
                // Special Case: Jump from Parteneri to Contact Details
                else if (routeName === 'GridContactDetalii') {
                    if (from.name === 'GridParteneri') {
                        // We want: Parteneri -> Contacte -> Detalii
                        // So we set GridContacte's parent to Parteneri
                        this.dynamicParents['GridContacte'] = from.name;

                        // Ensure Detalii points to Contacte (should be default in customParents, but just in case)
                        delete this.dynamicParents[routeName];
                    }
                    else if (from.name !== 'GridContacte') {
                        // If we didn't come from Contacte (e.g. from Dashboard or link),
                        // ensure GridContacte is reset to default (Dashboard)
                        delete this.dynamicParents['GridContacte'];
                        // And ensure Detalii uses default parent logic
                        delete this.dynamicParents[routeName];
                    }
                }
                // Generic logic for other Detail pages
                else if (routeName.includes('Detalii') && routeName !== 'GridContactDetalii') {
                    const isFromMenu = this.Menu.some((x: any) => x.Url === from.name);
                    if (isFromMenu || customParents[from.name] || this.dynamicParents[from.name]) {
                        this.dynamicParents[routeName] = from.name;
                    }
                }
            }

            let currentName = routeName;
            const crumbs: any[] = [];

            // Safety counter to prevent infinite loops in malformed trees
            let depth = 0;
            const maxDepth = 10;

            // Traverse up
            while (currentName && depth < maxDepth) {
                depth++;

                // Determine Title
                let title = customTitles[currentName];
                let url = currentName;

                // Try finding in Menu
                const menuItem = this.Menu.find((x: any) => x.Url === currentName);
                if (menuItem) {
                    title = title || menuItem.Title;
                }
                title = title || currentName;

                crumbs.unshift({ title: title, url: url });

                // Determine Parent
                // Priority: Dynamic -> Static Custom -> Menu Hierarchy
                let parentName = this.dynamicParents[currentName] || customParents[currentName];

                if (parentName) {
                    currentName = parentName;
                } else {
                    // Try to fall back to Menu hierarchy if we are stuck
                    if (menuItem && menuItem.MenuID) {
                        // Find parent in Menu
                        const parentItem = this.Menu.find((x: any) => x.ID == menuItem.MenuID);
                        if (parentItem) {
                            currentName = parentItem.Url || '';
                        } else {
                            // Fallback for root items
                            currentName = '';
                        }
                    } else {
                        // No parent found
                        currentName = '';
                    }
                }

                // Stop if we hit the same node (cycle protection)
                if (crumbs.length > 1 && crumbs[0].url === crumbs[1].url) break;
            }

            // Disable link for the last breadcrumb (current page)
            if (crumbs.length > 0) {
                crumbs[crumbs.length - 1].url = null;
            }

            this.breadcrumb = crumbs;

            if (crumbs.length > 0) {
                this.TabTitle = crumbs[crumbs.length - 1].title;
            }
        },
        markAsSeen() {
            // suprascris din composable la mounted
        }
    },
    mounted() {
        this.GetUser();
        this.loadCompaniesFromStorage();

        if (!this.companies.length) {
            CompanyServices.getAccessibleCompanies()
                .then((resp) => {
                    this.companies = (resp.data as Array<{ ID: string; Name: string }>)
                        .map(c => ({ ID: String(c.ID), Name: c.Name }));
                    localStorage.setItem('ERA_Companies', JSON.stringify(this.companies));


                    if (!this.currentCompanyId && this.companies.length) {
                        const first = this.companies[0];
                        localStorage.setItem('ERA_Company', JSON.stringify(first));
                        this.currentCompanyId = first.ID;
                    }
                }).catch(e => console.error('Nu pot încărca companiile:', e));
        }

        CompanyServices.getMenus()
            .then((response1: any) => {
                response1.data.forEach((x: any) => this.Menu.push(JSON.parse(x.MeniuConfig)));
                this.updateBreadcrumbs(this.$route);
            });

        const { changelog, newUpdates, hasNewUpdates, markAsSeen } = useChangelog();
        this.changelog = changelog;
        this.newUpdates = newUpdates;
        this.markAsSeen = () => {
            markAsSeen();
            this.showChangelog = false; // închide dialogul
        };

        // Doar ultima versiune
        this.latestUpdate = this.changelog.length ? [this.changelog[0]] : [];

        if (hasNewUpdates.value) this.showChangelog = true;
    },
    watch: {
        $route(to) {
            this.updateBreadcrumbs(to);
        }
    },
    computed: {
        currentCompanyName(): string {
            const current = this.companies.find(c => c.ID === this.currentCompanyId)
            return current?.Name ?? '—'
        },

    },

});
</script>
<style scoped>
/* ========== COMPACT TOP BAR ========== */
.premium-topbar {
    background: #ff5722 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.menu-btn {
    color: white !important;
}

/* ========== BRANDING ========== */
.app-branding {
    text-decoration: none;
    margin-left: 0.5rem;
    display: flex;
    align-items: baseline;
    gap: 0.4rem;
}

.brand-text {
    font-size: 1.25rem;
    font-weight: 700;
    color: white;
    letter-spacing: 0.05rem;
}

.brand-badge {
    font-size: 0.625rem;
    font-weight: 600;
    color: white;
    background: rgba(255, 255, 255, 0.2);
    padding: 0.125rem 0.375rem;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
}

/* ========== COMPANY SELECTOR ========== */
.company-selector {
    color: white !important;
    margin-left: 1rem;
    text-transform: none !important;
    font-weight: 500 !important;
    transition: background 0.2s;
    padding: 0.25rem 0.75rem !important;
}

.company-selector:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

.company-text {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
}

/* ========== COMPANY DROPDOWN ========== */
.company-dropdown {
    border-radius: 12px !important;
    overflow: hidden;
    min-width: 320px;
    max-width: 400px;
}

.dropdown-header {
    background: #ff5722;
    padding: 1rem 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dropdown-header-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.dropdown-title {
    color: white;
    font-weight: 600;
    font-size: 0.875rem;
}

.company-list {
    padding: 0.5rem !important;
    max-height: 400px;
    overflow-y: auto;
}

.company-list-item {
    border-radius: 8px;
    margin: 0.25rem 0;
    transition: all 0.2s;
    min-height: 48px !important;
}

.company-list-item:hover {
    background: rgba(255, 87, 34, 0.08) !important;
}

.company-avatar {
    transition: transform 0.2s;
}

.company-list-item:hover .company-avatar {
    transform: scale(1.05);
}

.company-name {
    font-weight: 500;
    font-size: 0.875rem;
}

/* ========== USER SECTION ========== */
.user-section {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    transition: background 0.2s;
    margin-left: 1rem;
}

.user-section:hover {
    background: rgba(255, 255, 255, 0.1);
}

.user-name {
    color: white;
    font-weight: 500;
    font-size: 0.875rem;
}

/* ========== VERSION BADGE ========== */
.version-badge {
    color: white !important;
    cursor: pointer;
    transition: background 0.2s;
    margin-left: 0.75rem;
}

.version-badge:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

/* ========== PREMIUM DRAWER ========== */
.premium-drawer {
    background: linear-gradient(180deg, #ff5722 0%, #f4511e 100%) !important;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15) !important;
}



/* ========== DRAWER MENU ========== */
.drawer-menu-list {
    padding: 0.75rem 0.5rem;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
}

.drawer-menu-list::-webkit-scrollbar {
    width: 6px;
}

.drawer-menu-list::-webkit-scrollbar-track {
    background: transparent;
}

.drawer-menu-list::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 4px;
    transition: background-color 0.2s;
}

.drawer-menu-list::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.4);
}

.menu-parent-item,
.menu-child-item,
.menu-grandchild-item,
.menu-single-item {
    border-radius: 6px;
    margin: 0.2rem 0.5rem;
    transition: all 0.25s ease;
}

.menu-parent-item:hover,
.menu-child-item:hover,
.menu-grandchild-item:hover,
.menu-single-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    transform: translateX(3px);
}

:deep(.v-list-item--active) {
    background: rgba(255, 255, 255, 0.2) !important;
    border-left: 3px solid white;
    padding-left: calc(16px - 3px) !important;
}

:deep(.v-list-group__items .v-list-item) {
    padding-left: 56px !important;
}

:deep(.v-list-item-title) {
    font-size: 0.875rem !important;
    font-weight: 500 !important;
}

:deep(.v-list-item .v-icon) {
    opacity: 0.9;
}

:deep(.v-list-item:hover .v-icon) {
    opacity: 1;
}

/* ========== DRAWER FOOTER ========== */
.drawer-footer-section {
    padding: 0.75rem;
    background: rgba(0, 0, 0, 0.12);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-divider {
    display: none;
}

.logout-item {
    border-radius: 6px;
    transition: all 0.25s ease;
}

.logout-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    transform: translateX(3px);
}

/* ========== MAIN CONTENT ========== */
:deep(.v-main) {
    background: linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%);
    height: 100vh;
    overflow: hidden;
}

.main-content-area {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.content-container {
    height: 100%;
    padding: 1.5rem !important;
    display: flex;
    flex-direction: column;
}

.content-card {
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

/* Fixed Header Section */
.card-header-fixed {
    flex-shrink: 0;
    background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
    border-bottom: 1px solid #e0e0e0;
}

.card-title-section {
    display: flex;
    align-items: center;
    padding: 1.5rem 2rem !important;
    font-weight: 700 !important;
    color: #333 !important;
    font-size: 1.5rem !important;
}

.breadcrumb-section {
    padding: 1rem 2rem 1rem 2rem;
    background: #fafafa;
}

.breadcrumb-custom {
    padding: 0 !important;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item) {
    font-size: 0.875rem;
    font-weight: 500;
    transition: color 0.2s;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item--link) {
    cursor: pointer;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item:hover) {
    color: #ff5722 !important;
}

.header-divider {
    opacity: 0.2;
}

/* Scrollable Content Section */
.card-content-scrollable {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.router-content {
    padding: 2rem;
    min-height: 100%;
}

/* Custom Scrollbar for Content */
.card-content-scrollable::-webkit-scrollbar {
    width: 8px;
}

.card-content-scrollable::-webkit-scrollbar-track {
    background: #f5f5f5;
}

.card-content-scrollable::-webkit-scrollbar-thumb {
    background-color: rgba(255, 87, 34, 0.3);
    border-radius: 4px;
    transition: background-color 0.2s;
}

.card-content-scrollable::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 87, 34, 0.5);
}

/* ========== BREADCRUMBS (Legacy) ========== */

/* ========== CHIPS ========== */
:deep(.v-chip) {
    font-weight: 600;
    transition: all 0.3s ease;
    border-radius: 8px;
}

:deep(.v-chip:hover) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* ========== DIALOGS ========== */
:deep(.v-dialog .v-card) {
    border-radius: 24px !important;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2) !important;
}

:deep(.v-dialog .v-card-title) {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0d5 100%);
    color: #ff5722 !important;
    font-weight: 700 !important;
    border-bottom: 1px solid #ffe0d5;
    padding: 1.5rem 2rem !important;
}

:deep(.v-dialog .v-card-text) {
    padding: 2rem !important;
}

:deep(.v-dialog .v-card-actions) {
    padding: 1.25rem 2rem !important;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
}

:deep(.v-dialog .v-btn) {
    text-transform: none !important;
    font-weight: 600 !important;
    border-radius: 10px !important;
    padding: 0.75rem 2rem !important;
    transition: all 0.3s ease;
}

:deep(.v-dialog .v-btn:hover) {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(255, 87, 34, 0.3);
}

/* ========== TIMELINE ========== */
:deep(.v-timeline) {
    padding-top: 0;
}

:deep(.v-timeline-item) {
    padding-bottom: 2rem;
}

:deep(.v-timeline .v-card) {
    border-radius: 14px !important;
    transition: all 0.3s ease;
    border-left: 3px solid #ff5722;
}

:deep(.v-timeline .v-card:hover) {
    transform: translateX(8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
}

/* ========== ANIMATIONS ========== */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.8;
    }
}

/* ========== LIST ENHANCEMENTS ========== */
:deep(.v-list) {
    background: transparent !important;
}

:deep(.v-list-item) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.v-list-group__header:hover) {
    background: rgba(255, 255, 255, 0.12) !important;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1280px) {
    .company-text {
        max-width: 180px;
    }

    .brand-text {
        font-size: 1.5rem;
    }
}

@media (max-width: 960px) {
    .company-selector {
        margin-left: 1rem;
    }

    .company-text {
        max-width: 140px;
    }

    .user-name {
        display: none;
    }

    .version-badge {
        margin-left: 0.5rem;
    }
}

@media (max-width: 600px) {
    .brand-badge {
        display: none;
    }

    .company-selector {
        margin-left: 0.5rem;
    }

    .version-badge {
        display: none;
    }

    :deep(.v-card-title) {
        font-size: 1.25rem !important;
        padding: 1.25rem 1.5rem !important;
    }

    :deep(.v-breadcrumbs) {
        padding: 0.75rem 1.5rem !important;
    }

    :deep(.v-container) {
        padding: 1rem !important;
    }
}

/* ========== UTILITY CLASSES ========== */
.text-white {
    color: white;
}

.no-underline {
    text-decoration: none;
}

/* ========== PREMIUM EFFECTS ========== */
:deep(.v-btn) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.v-btn:hover) {
    transform: translateY(-1px);
}

:deep(.v-icon) {
    transition: all 0.2s ease;
}

/* ========== SCROLLBAR GLOBAL ========== */
* {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 87, 34, 0.3) transparent;
}

*::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

*::-webkit-scrollbar-track {
    background: transparent;
}

*::-webkit-scrollbar-thumb {
    background-color: rgba(255, 87, 34, 0.3);
    border-radius: 4px;
    transition: background-color 0.2s;
}

*::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 87, 34, 0.5);
}
</style>
